import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { TrackData } from '../../models/app-track/track-data.model';
import { tap } from 'rxjs/operators';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root',
})
export class TrackingService {

  private apiUrl = `${ENV.HOST}${URL_MAP.API.TRACKING}`;
  //private apiUrl = 'http://localhost:9180/ova/api/tracking/registrar'; 

  constructor(private httpClient: HttpClient) {}

  /**
   * Env�a un evento de tracking al backend
   */
  // trackEvent(data: TrackData): Observable<any> {
  //   console.log('Tracking event:', data); // �til para pruebas

  trackEvent(trackData: TrackData): Observable<any> {
    console.log('TrackingService - Evento capturado: ', trackData);
    return this.httpClient.post(this.apiUrl, trackData).pipe(
      tap({
        next: (res) => console.log('TrackingService - Respuesta backend:', res),
        error: (err) => console.error('TrackingService - Error backend:', err)
      })
    );
  }
}
